module.exports = __webpack_public_path__ + "static/media/img2.bcbd4889.png";